import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      “No tenía familia, ni casa, ni siquiera nombre; el apodo de Pomarrosa se lo dieron en el mercado, a donde iba a
      hacer encargos y a alimentarse con las frutas pasadas que le regalaban las vendedoras. Los niños que tienen mamá y
      que tienen que tomar remedios sufrirían mucho si comieran todo lo que comía Pomarrosa”.
    </p>
    <p className="content justified">
      Oswaldo Díaz Díaz toma a Pomarrosa, una niña pequeña quien vive en indigencia, y la lleva a través de un mundo de
      fantasía donde aprende a vivir mejor que en el mundo cruel y hostil en el que se encuentra.
    </p>
    <p className="content justified">
      Una noche, “la noche del cuento”, Pomarrosa se refugió en el parque de costumbre para poder dormir sin ser
      descubierta por el guardia. Pero aquella noche no fue como las demás; por el contrario, fue realmente especial.
      Pomarrosa fue despertada por Merengue, su caballo favorito del carrusel, mientras todo en el parque estaba en
      armonía: la luna brillaba, los pájaros cantaban y las ranas bailaban.
    </p>
    <p className="content justified">
      De repente, Merengue fue sorprendido por un relincho. El caballo de bronce del general que estaba en el monumento
      del parque había saltado de su puesto y estaba invitando a Merengue a una carrera.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Tanto el general como Pomarrosa montaron sus corceles y emprendieron la carrera. En un momento, el general cayó de
      su caballo y se lastimó un tobillo. Pomarrosa, quien tenía tan buen corazón, ayudó al general a volver a su puesto
      en el parque.
    </p>
    <p className="content justified">
      Hablaron por un largo rato y el general “le enseñó muchas cosas: primero, a no hacerle caso a la lluvia cuando
      azota el rostro y cala la ropa; luego, a no preocuparse del hambre ni de la sed, a dejar que los pajaritos se
      suban a nuestros hombros, sin hacerles daño, a mirar siempre de frente, a no hacer visajes con el rostro, a
      contemplar las multitudes como si en realidad no existieran, y muchas cosas interesantes que saben hacer las
      estatuas de bronce”.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">Del realismo a la fantasía</h3>
      <p className="content justified">
        Este texto, publicado en la revista <i>Rin Rin</i> y en tres antologías de cuentos, es uno de los más
        interesantes de Oswaldo Díaz Díaz, ya que utiliza la imagen de una niña que vive en condiciones indeseables para
        cualquier ser humano y la fantasía se convierte en una herramienta de transformación interior para vivir un poco
        mejor en medio de las dificultades.
      </p>
      <p className="content justified">
        La magia no es en este caso un artificio para modificar el mundo; por el contrario, la realidad de Pomarrosa
        sigue siendo la misma, pero la que cambió fue ella, con ayuda de los consejos del general que ha pasado muchos
        días siendo una estatua y viendo el comportamiento de los seres humanos.
      </p>
      <p className="content justified">
        Este cuento nos recuerda a “La pequeña vendedora de cerillas” de Hans Christian Andersen, uno de los autores más
        reconocidos de la literatura infantil, del que Díaz Díaz tenía amplio conocimiento. Estos dos escritores
        hicieron protagonistas de sus historias a dos niñas que viven en condiciones precarias y la fantasía les permite
        posicionarse de una nueva forma frente a su dura realidad. En el caso del autor danés, la muerte es la salida de
        la pequeña vendedora de cerillas en medio del frío y la nieve. Pero para Don Os, el final de Pomarrosa, aunque
        incierto, es esperanzador.
      </p>
      <p className="content justified">
        Además, puede pensarse que en este cuento existe una crítica a la indiferencia de la sociedad frente a los
        marginados, a quienes dejan de ver como seres humanos o que son simplemente invisibilizados. De ahí que
        Pomarrosa puede aplicar al pie de la letra los consejos de una estatua inmóvil y sin vida.
      </p>
      <p className="content justified">
        “Pomarrosa en el parque” nos habla de una realidad dolorosa y vigente en la sociedad colombiana, trata de la
        valentía y la indiferencia, de los privilegios y de la capacidad de transformación.
      </p>
    </div>
  </div>
);
